import React from 'react';
import { connect } from 'react-redux';
import { Grid, Card } from 'semantic-ui-react';
import TimelineWidget from 'components/Dashboard/TimelineWidget/TimelineWidget';
import Loader from 'components/Loader/Loader';
import { LotTimelineContextProvider } from 'contexts/LotTimelineContext';
import { AppState } from 'reducers/reducers';
import { selectedSpotInfo } from 'selectors';

type LotTimelineContainerProps = ReturnType<typeof mapStateToProps>;

const LotTimelineContainer = ({ currentSpot }: LotTimelineContainerProps): JSX.Element => {
    if (!currentSpot) return <Loader />;

    return (
        <Card fluid>
            <Card.Content>
                <Grid stackable>
                    <LotTimelineContextProvider>
                        <TimelineWidget spot={currentSpot} />
                    </LotTimelineContextProvider>
                </Grid>
            </Card.Content>
        </Card>
    );
};

function mapStateToProps(state: AppState) {
    return {
        currentSpot: selectedSpotInfo(state),
    };
}

export default connect(mapStateToProps, null)(LotTimelineContainer);
